import { Plan } from "./types";

export enum PricingPlanType {
  FreeAccount = "free-account",
  SubscribeLite = "subscribe-lite",
  SubscribePro = "subscribe-pro",
  SubscribeVolume = "subscribe-volume",
  Payg = "payg",
}

export function fromSubscriptionPlan(plan: Plan): PricingPlanType {
  if (plan.name === "Personal") {
    return PricingPlanType.SubscribeLite;
  } else if (plan.monthlyCredits === 200) {
    return PricingPlanType.SubscribePro;
  } else {
    return PricingPlanType.SubscribeVolume;
  }
}
